<template>
  <!-- <pre v-if="responseData">  test data :: {{ responseData.data.data_tahunan }}</pre>  -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PBTCare.png"
        alt="PBTCare"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppDateTimePicker           
            v-model="dateRange"
            label="Tarikh"
            placeholder="Pilih Tarikh"
            :config="{ mode: 'range' }"
            class="app-date-picker custom-picker"
          />
        </div>
        
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedMonth"
            label="Bulan"
            :items="months"
            placeholder="Pilih Bulan"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
            @update:model-value="onYearChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states.map(s => (typeof s === 'object' ? s.name : s))"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>JUMLAH ADUAN TAHUNAN</h2>
      <div class="chart-wrapper">  
        <Bar 
          :chart-data="jumlahAduanList"
          :chart-categories="tahunList"
          chart-title="Jumlah Aduan Tahunan"
          y-axis-title="Jumlah Aduan"
          :chart-colors="['#42a5f5']"
        />
        <div class="kolam">
          <div class="kolam-container">
            <img
              src="@/assets/spah/box.png"
              alt="First Image"
              class="responsive-image"
            >
            <div class="text-overlay">
              <div class="values-layered">
                <h3>Jumlah Keseluruhan Aduan</h3>
                <p class="num">
                  {{ jumlahKeseluruhan || 0 }}
                </p>
              </div>
            </div>
          </div>

          <div class="kolam-container">
            <img
              src="@/assets/spah/box.png"
              alt="Second Image"
              class="responsive-image"
            >
            <div class="text-overlay">
              <div class="values-layered">
                <h3>Jumlah Aduan Baharu</h3>
                <p class="num">
                  {{ dataStatus.Baharu || 0 }}
                </p>
              </div>
            </div>
          </div>

          <div class="kolam-container">
            <img
              src="@/assets/spah/box.png"
              alt="Second Image"
              class="responsive-image"
            >
            <div class="text-overlay">
              <div class="values-layered">
                <h3>Jumlah Aduan Dalam Tindakan</h3>
                <p class="num">
                  {{ dataStatus["Dalam Tindakan"] || 0 }}
                </p>
              </div>
            </div>
          </div>

          <div class="kolam-container">
            <img
              src="@/assets/spah/box.png"
              alt="Second Image"
              class="responsive-image"
            >
            <div class="text-overlay">
              <div class="values-layered">
                <h3>Jumlah Aduan Telah Selesai</h3>
                <p class="num">
                  {{ dataStatus.Selesai || 0 }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2>STATISTIK JUMLAH ADUAN MENGIKUT KATEGORI</h2>
      <div class="chart-wrapper">  
        <Nightingale :chart-data="kategoriData" />
      </div>
    </div>
  </AdminBackground>
  <PrimaryModule />
  <InspektoratMenu />
</template>

<script setup>
import { useHttpService } from "@/httpService"
import { onMounted, ref, toRaw, watch } from "vue"

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const { httpGet } = useHttpService()

const months = ref([
  "Semua Bulan",  
  "January",
  "February",
  "Mac",
  "April",
  "Mei",
  "Jun", 
  "Julai",
  "Ogos",
  "September",
  "Oktober",
  "November",
  "Disember",
])

const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref('Semua Tahun')
const years = ref([])
const selectedMonth = ref('Semua Bulan') 
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const dateRange = ref([])
const responseData = ref(null)
const tahunList = ref([])
const jumlahAduanList = ref([])
const jumlahKeseluruhan = ref(0)
const dataStatus = ref({})
const kategoriData = ref([])

async function loadDataFromApi(
  dateFrom, dateTo,
  month = selectedMonth.value, 
  year = selectedYear.value, 
  state = selectedsState.value, 
  pbtValue = selectedPbt.value,
) {
  try {
    const plainStates = toRaw(state)
    
    let queryParams = `year=${year === "Semua Tahun" ? "all" : year}`

    if (month === "Semua Bulan") {
      queryParams += `&month=all`
    } else {
      const monthIndex = months.value.indexOf(month) + 1 

      queryParams += `&month=${monthIndex}`
    }
    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const matchedState = states.value.find(s => s.name === state)
          if (matchedState) {
            queryParams += `&states[]=${matchedState.id}`
          }
        })
      } else {
        const matchedState = states.value.find(s => s.name === plainStates)
        if (matchedState) {
          queryParams += `&states[]=${matchedState.id}`
        }
      }
    }
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }
    const url = `inspektorat/itegur?date_start=${dateFrom}&date_end=${dateTo}${queryParams}`
    const response = await httpGet(url)

    if (!response || !response.data || !response.data.data_tahunan) {
      tahunList.value = []
      jumlahAduanList.value = []
      
      return
    }

    years.value = ["Semua Tahun", ...response.years.sort((a, b) => b - a)]
    states.value = ["Semua Negeri", ...response.states.map(state => state.name)]
    if (response.states) {
      response.states.forEach(state => {
        if (state && state !== "Modified Pbt") {
          states.value.push({ name: state.name, id: state.id })
        }
      })
    }
    councils.value = response.councils || {}
    responseData.value = response

    let tahunData = Object.values(response.data.data_tahunan || {})

    if (!tahunData.length) {
      console.warn("No 'data_tahunan' available for selected filters.")
      tahunList.value = []
      jumlahAduanList.value = []
      
      return
    }
    tahunData.sort((a, b) => a.tahun - b.tahun)

    if (year !== "Semua Tahun") {
      tahunData = tahunData.filter(item => item.tahun == year)
    }
    tahunList.value = tahunData.length ? tahunData.map(item => item.tahun) : []
    jumlahAduanList.value = tahunData.length ? tahunData.map(item => item.jumlah_aduan) : []

    if (!jumlahAduanList.value.length) {
      console.warn("Jumlah Aduan List is empty. Chart may not render.")
    }

    jumlahKeseluruhan.value = jumlahAduanList.value.reduce((acc, val) => acc + val, 0)

    if (response.data.data_status) {
      dataStatus.value = response.data.data_status
    }
    if (response.data.data_kategori) {
      kategoriData.value = Object.entries(response.data.data_kategori).map(
        ([name, value]) => ({ name, value }),
      )
    }
  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}
function onYearChange(value) {
  if (value === "Semua Tahun") {
    selectedYear.value = "Semua Tahun"
  } else {
    selectedYear.value = value
  }
  loadDataFromApi(dateRange.value?.[0], dateRange.value?.[1])
}
function handleStateChange() {
  pbt.value = []
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }
  if (selectedsState.value.includes("Semua Negeri")) {
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state]) {
        pbt.value.push(...councils.value[state].map(council => council.value))
      }
    })
  } else {
    selectedsState.value.forEach(state => {
      if (councils.value && councils.value[state]) { 
        pbt.value.push(...councils.value[state].map(council => council.value))
      } else {
        console.warn(`No councils found for state: ${state}`)
      }
    })
  }
}
onMounted(() => {
  loadDataFromApi()

  const defaultDateFrom = '2014-01-01T00:00:00.000Z'
  const defaultDateTo = new Date().toISOString()

  loadDataFromApi(defaultDateFrom, defaultDateTo)
})
watch(dateRange, newDateRange => {
  if (newDateRange && newDateRange.length === 24) {
    const dateFrom = newDateRange.substring(0, 10)
    const dateTo = newDateRange.substring(14)

    loadDataFromApi(dateFrom, dateTo)
  }
})

watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })

watch([selectedMonth, selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedMonth.value, selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-block-end: 20px;
}

.button-wrapper {
  margin-block-start: 40px;
  margin-inline-start: 10px;
}

.filter-btn {
  border: none;
  border-radius: 5px;
  background-color: #13017f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 10%);
  color: white;
  cursor: pointer;
  font-size: 1rem;
  margin-inline-start: 40px;
  padding-block: 10px;
  padding-inline: 20px;
}

.filter-btn:hover {
  background-color: #001f73;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-inline-end: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-inline-end: 0;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}

h1 {
  position: relative;
  color: white;
  font-size: 2rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block-end: 20px;
  text-align: center;
}

h1::after {
  display: block;
  border-radius: 3px;
  background-color: white;
  block-size: 5px;
  content: "";
  inline-size: 40%;
  margin-block: 10px 0;
  margin-inline: auto;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: start;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  block-size: auto;
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

.kolam {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-block-end: 30px;
}

.kolam-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 48%;
  margin-block-end: 20px;
}

.responsive-image {
  display: block;
  border-radius: 10px;
  block-size: auto;
  inline-size: 100%;
}

.text-overlay {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Arial, sans-serif;
  inset: 0;
  text-align: center;
}

.values-layered h3 {
  margin: 0;
  color: #150069;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
}

.num {
  color: #a80000;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

@media (max-width: 1200px) {
  .content-wrapper,
 .chart-wrapper {
    padding: 15px;
  }

  h1 {
    font-size: 1.8rem;
  }

  h2 {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .top-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .nav-links {
    flex-direction: column;
    gap: 10px;
  }

  .logo {
    block-size: 25px;
  }

  h1 {
    font-size: 1.6rem;
  }

  h2 {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper,
 .chart-wrapper {
    padding: 10px;
  }

  h1 {
    font-size: 1.4rem;
  }

  h2 {
    font-size: 1rem;
  }
}
</style>
